import { render, staticRenderFns } from "./StudentReserve.vue?vue&type=template&id=49e1758f&"
import script from "./StudentReserve.vue?vue&type=script&lang=js&"
export * from "./StudentReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports